<div class="banner">
  <ul class="nav-list">
    <li class="nav-list-item hide-mobile">
      <a routerLink="/" class="button">Welkom</a>
    </li>

    <li *ngIf="!currentAccount" class="nav-list-item hide-mobile">
      <a routerLink="/demo-onboarding" class="button">Demo</a>
    </li>

    <li class="nav-list-item hide-mobile">
      <a routerLink="/how-it-works" class="button">Hoe werkt het</a>
    </li>

    <li class="nav-list-item hide-mobile">
      <a routerLink="/about" class="button">Wie zijn wij</a>
    </li>

    <li class="nav-list-item empty">
    </li>

    <li class="social-link-list-item hide-mobile">
      <a href="https://www.facebook.com/bruiloftinjebroekzak/" target="_blank">
        <fa-icon [icon]="['fab', 'facebook']"></fa-icon>
      </a>
    </li>

    <li class="social-link-list-item hide-mobile">
      <a href="https://www.instagram.com/bruiloftinjebroekzak/" target="_blank">
        <fa-icon [icon]="['fab', 'instagram']"></fa-icon>
      </a>
    </li>

    <li *ngIf="!currentAccount" class="nav-list-item admin hide-mobile">
      <a routerLink="/login" class="button button-primary">Log in</a>
    </li>

    <li *ngIf="currentAccount" class="nav-list-item admin hide-mobile">
      <a routerLink="/workshop/workbench" class="button button-primary">Mijn feest</a>
    </li>

    <li class="nav-list-item hide-mobile help">
      <a href="//help.bruiloftinjebroekzak.nl" class="button button-subtle" target="_blank" title="Help">
        <fa-icon [icon]="['far', 'question-circle']"></fa-icon>
      </a>
    </li>

    <li class="nav-list-item show-mobile">
      <app-mobile-menu [account]="currentAccount"></app-mobile-menu>
    </li>
  </ul>
</div>
